import { isString, times } from 'lodash';
import { numberFormat } from '@fiverr-private/localization';
import { STAR_COUNT_CONFIG } from '../constants';
import Star from '../Star';

/**
 * Returns an array of star themes according to the rating theme and score.
 *
 * @param {String} theme - The rating theme.
 * @param {Number} score - The rating score.
 * @returns {String[]}
 */
export const formatStars = (theme, score) => {
    const starCount = STAR_COUNT_CONFIG[theme];

    return times(starCount).map((index) =>
        calculateStarTheme(score, index)
    );
};

/**
 * Returns a star theme calculated according to the score and it's index.
 *
 * @param {Number} score - The rating score.
 * @param {Number} starIndex - The star index.
 * @returns {String}
 */
const calculateStarTheme = (score, starIndex) => {
    const normalizedScore = Math.round(score * 2) / 2;
    const filledStarCount = Math.floor(normalizedScore);
    const remainderStar = normalizedScore - filledStarCount;

    switch (true) {
        case starIndex < filledStarCount:
            return Star.THEMES.FULL;
        case starIndex === filledStarCount && remainderStar === 0.5:
            return Star.THEMES.HALF;
        default:
            return Star.THEMES.EMPTY;
    }
};

/**
 * Returns formatted score.
 *
 * @param {Number} score - The rating score.
 * @param {Record<'minimumFractionDigits'|'maximumFractionDigits', number>} options - Number format options.
 * @returns {String}
 */
export const formatScore = (score, options = {}) => numberFormat({ value: score, options: {
    fallbackValue: score,
    ...options
} });

/**
 * Returns formatted ratings count.
 *
 * @param {Number | String} ratingsCount - The total amount of ratings.
 * @returns {String}
 */
export const formatRatingsCount = (ratingsCount) => {
    if (isString(ratingsCount)) {return ratingsCount;}

    return numberFormat({ value: ratingsCount, options: {
        noFractionDigits: true,
        fallbackValue: ratingsCount
    } });
};
